import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'loyalty-tier-container',
})
export default class LoyaltyTierContainer extends Vue {}
